module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_CS-c99906980d2a3ccd671a54cbfc4deb0f.svg";